import { render, staticRenderFns } from "./SkeletonChart.vue?vue&type=template&id=1fda5aec&scoped=true"
import script from "./SkeletonChart.vue?vue&type=script&lang=js"
export * from "./SkeletonChart.vue?vue&type=script&lang=js"
import style0 from "./SkeletonChart.vue?vue&type=style&index=0&id=1fda5aec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fda5aec",
  null
  
)

export default component.exports